import React from 'react';

const SETTING_CONTROLS = [
  {
    key: 'minGreen',
    label: 'Key strength',
    min: 28,
    max: 120,
    step: 1,
    format: (value) => value
  },
  {
    key: 'softness',
    label: 'Edge softness',
    min: 18,
    max: 120,
    step: 1,
    format: (value) => value
  },
  {
    key: 'greenBias',
    label: 'Green tolerance',
    min: 85,
    max: 105,
    step: 1,
    scale: 0.01,
    format: (value) => value.toFixed(2)
  },
  {
    key: 'minSaturation',
    label: 'Saturation floor',
    min: 2,
    max: 30,
    step: 1,
    scale: 0.01,
    format: (value) => value.toFixed(2)
  },
  {
    key: 'spill',
    label: 'Spill suppression',
    min: 0,
    max: 100,
    step: 1,
    scale: 0.01,
    format: (value) => value.toFixed(2)
  },
  {
    key: 'spillDominance',
    label: 'Spill sensitivity',
    min: 4,
    max: 20,
    step: 1,
    format: (value) => value
  },
  {
    key: 'spillMinGreen',
    label: 'Spill green floor',
    min: 40,
    max: 120,
    step: 1,
    format: (value) => value
  }
];

function toSliderValue(setting, value) {
  if (setting.scale) {
    return Math.round(value / setting.scale);
  }

  return value;
}

function fromSliderValue(setting, rawValue) {
  const numericValue = Number(rawValue);

  if (setting.scale) {
    return numericValue * setting.scale;
  }

  return numericValue;
}

function SettingControl({ setting, value, onChange }) {
  const sliderValue = toSliderValue(setting, value);

  return (
    <label className='flex flex-col gap-1'>
      <div className='flex items-center justify-between gap-2 text-sm'>
        <span>{setting.label}</span>
        <span className='tabular-nums text-gray-600'>
          {setting.format(value)}
        </span>
      </div>
      <input
        type='range'
        min={setting.min}
        max={setting.max}
        step={setting.step}
        value={sliderValue}
        onChange={(event) =>
          onChange(fromSliderValue(setting, event.target.value))
        }
      />
    </label>
  );
}

function ChromaKeyControls({ settings, setSettings }) {
  const updateSetting = (key, value) => {
    setSettings((current) => ({
      ...current,
      [key]: value
    }));
  };

  return (
    <div className='flex flex-col gap-4 h-fit max-h-full overflow-y-auto bg-white/90 p-4 rounded-md'>
      <h2 className='text-lg font-bold'>Chroma Key Controls</h2>
      <div className='flex flex-col gap-3'>
        {SETTING_CONTROLS.map((setting) => (
          <SettingControl
            key={setting.key}
            setting={setting}
            value={settings[setting.key]}
            onChange={(value) => updateSetting(setting.key, value)}
          />
        ))}
      </div>
    </div>
  );
}

export default ChromaKeyControls;
